import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { clone } from '../../../common/extensions';
import { HubApiService } from '../../../services/hub.api.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { AddCityModalActions, AddCityModalData } from './add.city.modal.provider';

@Component({
    templateUrl: './add.city.modal.component.html',
    styleUrls: ['./add.city.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AddCityModalComponent extends BaseComponent {

    public searchFormGroup: FormGroup;
    public data: any;
    public searchText: string;
    public allCities: any;

    constructor(private dialogRef: MatDialogRef<AddCityModalComponent>,
                private actions: AddCityModalActions,
                private formBuilder: FormBuilder,
                private hubApiService: HubApiService,
                data: AddCityModalData,
    ) {
        super();
        this.data = Object.assign({}, data);
        this.allCities = clone(this.data.locationFeeds);
        this.searchFormGroup = this.formBuilder.group({
            'search': [null],
        });
    }

    public close(): void {
        this.dialogRef.close();
    }

    public search() {
        if (this.searchText) {
            this.data.locationFeeds = this.allCities.filter(x => x.locationFeed.cityTitle.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0);
        } else {
            this.data.locationFeeds = clone(this.allCities);
        }
    }

    public toggle(feed) {
        //feed.isInRegion = !feed.isInRegion;

        setTimeout(() => {
            this.data.locationFeeds.forEach(x => {
                if (x.locationFeed.id === feed.locationFeed.id) {
                    x.isInRegion = feed.isInRegion;
                }
            });
            this.allCities.forEach(x => {
                if (x.locationFeed.id === feed.locationFeed.id) {
                    x.isInRegion = feed.isInRegion;
                }
            });
        });
    }

    public async confirm(event: ButtonTriggerEvent) {
        let cities = this.allCities.filter(x => x.isInRegion).map(y => y.locationFeed.id);
        console.log(cities);
        this.hubApiService.addCitiesToRegion(this.data.hubName, this.data.regionId, cities).subscribe(data => {
            this.actions.confirm(event, cities);
            this.dialogRef.close();
        });
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/add.city.modal/add.city.modal.component.ts